import type { RequestConfig } from '@customTypes/index';
import type { PaymentsDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type PostClubProfilePaymentsRequest = {
  clubId: string;
  data: PaymentsDto;
};

export type PostClubProfilePaymentsParams =
  RequestConfig<PostClubProfilePaymentsRequest>;

export const postClubProfilePayments = async ({
  params,
  config
}: PostClubProfilePaymentsParams) =>
  api.post(`/api/ClubProfile/payments/${params.clubId}`, params.data, config);
